import { Box, Divider } from '@mui/material';
import SparkSectionHeader from '../SparkSectionHeader';
import { SparkFormImageGallery } from 'sharedComponents/SparkForm';

function Gallery() {
  return (
    <Box>
      <Divider
        sx={{ width: '100%', marginBottom: '25px', marginTop: '25px' }}
      />
      <SparkSectionHeader
        headerText='Gallery'
        subHeaderText=' We recommend at least 3 or more images'
      />
      <SparkFormImageGallery name='sparkImages' maxImagesCount={5} />
    </Box>
  );
}

export default Gallery;
